/*
 *  -----------------------------------------------------------------------
 *    <copyright file="status-label/index.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2023 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import cn from 'clsx';
import React from 'react';
import { StatusLabelProps } from '@components/core/status-label/status-label.interface';
import './styles.scss';

const StatusLabel = ({ text, status }: StatusLabelProps) => <p className={cn('status-label', status)}>{text}</p>;

export default StatusLabel;
